export default __webpack_public_path__ + "37b2cd9d5360df3855c3f518c9051167.png";